import axiosClient from "api/axios_client.js";

const RULE = "/reminder-builder/reminder-designer/rule";
const DELIVERY = "/reminder-builder/reminder-monitor/delivery";

// Calls shared by the Reminder Monitor tabs.
const apiReminderMonitor = {
  // Rules for the "Rule" filter of every tab.
  getRuleOptions:    ()           => axiosClient.get(`${RULE}/get-all`),
  // The messages of one case (latest first, at most 500): the case drawer's timeline.
  getCaseDeliveries: (instanceId) => axiosClient.get(`${DELIVERY}/get-all`, { params: { instance_fid: instanceId } }),
};

export default apiReminderMonitor;
